module.exports = __webpack_public_path__ + "img/D-info-01.a10265c3.png";